import { ButtonVariant } from './../form/nicky-button/nicky-button.component';
import { Component, Input, Output, EventEmitter, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NickyButtonComponent } from '../form/nicky-button/nicky-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-settings-section',
  imports: [CommonModule, NickyButtonComponent, MatIconModule, TranslateModule],
  templateUrl: './settings-section.component.html',
})
export class SettingsSectionComponent {
  @Input() sectionTitle!: string;
  @Input() subtitle!: string;
  @Input() titleId!: string;
  @Input() buttonId: string | undefined = 'settings-header-save';
  @Input() expandButtonIsDisabled: boolean = false;
  @Input() modalButtonIsDisabled: boolean = false;

  @Input() borderRounded: boolean = true;
  @Input() expandIcon: boolean = false;
  @Input() horizontal: boolean = false;
  @Input() showButton: boolean = false;
  @Input() buttonIcon: string | undefined = undefined;
  @Input() inputId: string | undefined = undefined;
  @Input() buttonText: string = '';
  @Input() buttonVariant: ButtonVariant = 'primary';
  @Input() showTourIcon = false;

  buttonClick = output();
  toggleExpand = output();

  @Output() onTour = new EventEmitter<void>();
}
